export default __webpack_public_path__ + "static/media/usdcbomb.1289a2f5.png";